import { render, staticRenderFns } from "./HealthCheck45PsaThyroidRegister.vue?vue&type=template&id=6ac5bbf4&scoped=true&"
import script from "./HealthCheck45PsaThyroidRegister.vue?vue&type=script&lang=js&"
export * from "./HealthCheck45PsaThyroidRegister.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck45PsaThyroidRegister.vue?vue&type=style&index=0&id=6ac5bbf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac5bbf4",
  null
  
)

export default component.exports